import { render } from "./InputGroupText.vue?vue&type=template&id=70fa4704"
import script from "./InputGroupText.vue?vue&type=script&lang=js"
export * from "./InputGroupText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__